import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-plus-jakarta-sans\",\"display\":\"swap\"}],\"variableName\":\"plusJakartaSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/tailwind.css");
